import React, { useState } from 'react';
import './side.css'
import Main from './package'
import { getsitedata, logout } from "./../action/user";
import DeleteConfirmationModal from './deleteConfirmationModal';

function Side() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const onlogout = async () => {
    var test = await logout();
    window.location = "/";
  }
  return (
    <>
      <div className='row'>
        <div className='col-md-2'>
          <div className="sidebar">
            <a href='/myprofile'>My Profile</a>
            <a href='/showCard'>Viewed by me</a>
            <a href='/anotherviewed'>Viewed by others</a>
            <a href='/saved'>Favourites</a>
            <a className="active" href='/membership'>Membership Details</a>
            <a href='/req-horoscope'>Request for Horoscope</a>
            <a href='/horoscope-reqs'>Horoscope Requests</a>
            <a href='/moreinfo-reqs'>Request Full Profile</a>
            <a href='/profile-reqs'>Profile Requests</a>
            <a onClick={() => setIsModalOpen(true)} style={{ cursor: 'pointer' }}>
              Delete Account
            </a>
            <a onClick={onlogout}>Logout</a>
          </div>
        </div>
        <div className='col-md-10'>

          <div className="contents">
            <Main />
          </div>
        </div>
        <DeleteConfirmationModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      </div>
    </>

  );
}
export default Side;


